import axios from 'axios'
let path = '/oog202'
let baseUrl = 'http://192.168.10.78' + path //HAS
// let baseUrl = 'http://192.168.10.207:8003' + path //HAS
if(process.env.NODE_ENV === 'production'){
    baseUrl = path
}
if(process.env.NODE_ENV === 'test'){
    baseUrl = 'http://laien.test' + path
}
console.log(baseUrl)
// const baseUrl = 'http://192.168.50.164/oog202/' //5GHz
export default {
    axios_1:axios.create({
        baseURL:baseUrl, //location
        timeout:40000,
    }),
    axios_2:axios.create({
        baseURL:baseUrl, //location
        timeout:0,
    }),
    // 清除代理缓存接口
    clearCache:axios.create({
        baseURL:'https://api.cloudflare.com/client/v4/zones/fc8483e41477b3901838fbca7c051665/purge_cache',
        timeout:0
    }),
    default_img_url:'',
    imgUploadUrl:baseUrl,
}